import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {  CheckRoleDirective } from './pipe/check-role.directive';
import {  CheckSpaceRoleDirective } from './pipe/check-space-role.directive';


@NgModule({
 imports:      [ CommonModule ],
 declarations: [ CheckRoleDirective, CheckSpaceRoleDirective ],
 exports:      [ CheckRoleDirective, CheckSpaceRoleDirective, CommonModule ]
})
export class SharedModule { }
